<template>
  <div>
    <m-form
        :title="title"
        :items="listItems"
        :cols="headers"
        :showActions="false"
        :canSubmit="false"
        :canDelete="false"
        :showListBtn="false"
        :show-navigation-btns="false"
        :show-clear-btn="false"
    >
      <template #header-btns>
        <v-btn
            depressed
            @click="openConfirmDialog('cancel-closing')"
            :disabled="!financialYear.is_closed"
            class="rounded-lg accent white--text"
        >لغو بستن سال مالی جاری</v-btn
        >
      </template>

      <template #default>
        <v-row>
          <v-col cols="12">
            <v-autocomplete
                class="rounded-lg"
                :return-object="true"
                label=" * سال مالی جدید"
                :items="selectItems"
                v-model="targetFinancialYear"
                item-text="name"
                item-value="id"
                :multiple="false"
            />
          </v-col>

          <v-col cols="12" md="4">
            <v-checkbox v-model="entities.accounts" label="حساب ها" hide-details></v-checkbox>
          </v-col>
          <v-col cols="12" md="4">
            <v-checkbox v-model="entities.wares" label="کالا ها" hide-details></v-checkbox>
          </v-col>
          <v-col cols="12" md="4">
            <v-checkbox v-model="entities.cheques" label="چک ها" hide-details v-if="false"></v-checkbox>
          </v-col>

          <v-col class="d-flex justify-start">
            <v-btn
                class="rounded-lg info white--text "
                @click="incomeStatementDialog=true"
                depressed
            >
              <v-icon x-small color="white" class="ml-1"> fa-eye </v-icon>
              مشاهده صورت سود و زیان

            </v-btn>
            <v-btn
                class="rounded-lg info white--text mr-2"
                @click="balanceDialog=true"
                depressed
            >
              <v-icon x-small color="white" class="ml-1"> fa-eye </v-icon>
              مشاهده ترازنامه

            </v-btn>
          </v-col>
          <v-col class="d-flex justify-end">
            <v-btn
                depressed
                :disabled="financialYear.is_closed || !canPerform"
                @click="openConfirmDialog('close-and-move')"
                class="rounded-lg success white--text w-100px"
            >بستن و انتقال</v-btn
            >
            <v-btn
                depressed
                :disabled="financialYear.is_closed || !canPerform"
                @click="openConfirmDialog('move')"
                class="rounded-lg success white--text w-100px mr-2"
            >انتقال</v-btn
            >
          </v-col>
        </v-row>

        <v-dialog v-model="confirmDialog" scrollable max-width="550px" transition="dialog-transition" v-if="operation">
          <v-card class="error white--text">
            <v-card-title class="text--center">آیا از انجام این عملیات اطمینان دارید؟</v-card-title>

            <v-card-text class="white--text">
              <div v-if="operation == 'cancel-closing'">بسته شدن سال مالی لغو می شود و سند های بستن خالی می گردند</div>
              <div v-if="operation == 'close-and-move'">
                <span class="white black--text mx-1 px-1 rounded">سال مالی {{ financialYear.name }}</span>
                بسته می شود و به
                <span class="white black--text mx-1 px-1 rounded">سال مالی {{ targetFinancialYear.name }}</span>
                انتقال پیدا میکند
              </div>
              <div v-if="operation == 'move'">
                <span class="white black--text mx-1 px-1 rounded">سال مالی {{ financialYear.name }}</span>
                به
                <span class="white black--text mx-1 px-1 rounded">سال مالی {{ targetFinancialYear.name }}</span>
                انتقال می کند
              </div>
              <div v-if="operation == 'close-and-move'">
                <v-banner class="rounded-lg mt-7 mb-1 white--text">
                  <v-avatar
                      slot="icon"
                      color="white"
                      size="25"
                  >
                    <v-icon
                        color="error"
                    >
                      fa-times
                    </v-icon>
                  </v-avatar>
                  ابتدا مانده موجودی کالا را انبارگردانی کرده سپس به صورت دقیق انتقال دهید، در غیر اینصورت با انتقال مانده اشتباه
                  و صدور فاکتور در سال مالی جدید مانده ابتدا دوره قابل ویرایش نیست!
                </v-banner>

              </div>
              <div class="mt-5">
                <span>رمز عبور</span>
              </div>
              <v-text-field
                  type="password"
                  class="mt-1 text-field-ltr rounded-lg"
                  hide-details
                  color="error"
                  v-model="password"
              />
            </v-card-text>
            <v-card-actions class="white d-flex justify-center">
              <v-btn depressed @click="confirm" class="rounded-lg" color="error white--text">تایید و انجام عملیات</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
    </m-form>

    <sort-inventory-error
        v-if="errorDialog"
        title="اتمام عملیات به دلیل منفی شدن کالا های زیر در مرتب سازی کاردکس کالا امکان پذیر نیست"
        v-model="errorDialog"
        :errors="errors"
    />

    <v-dialog v-model="balanceDialog" scrollable max-width="90%" transition="dialog-transition">
      <v-card class="white rounded-lg">
        <v-card-title class="secondary white--text">تراز نامه
        <v-spacer></v-spacer>
          <v-btn icon @click="balanceDialog=false">
            <v-icon color="primary">fa-times</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="white--text">
          <balance-sheet :is-dialog="true"></balance-sheet>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="incomeStatementDialog" scrollable max-width="90%" transition="dialog-transition">
      <v-card class="white rounded-lg">
        <v-card-title class="secondary white--text">صورت سود و زیان
          <v-spacer></v-spacer>
          <v-btn icon @click="incomeStatementDialog=false">
            <v-icon color="primary">fa-times</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="white--text">
          <income-statement :is-dialog="true"></income-statement>
        </v-card-text>
      </v-card>
    </v-dialog>

  </div>
</template>
<script>
import CompanyMixin from "@/views/panel/company/mixin";
import { MFormMixin } from "@/components/m-form";
import SortInventoryError from "@/components/SortInventoryError";
import IncomeStatement from "@/views/panel/incomeStatement/IncomeStatement";
import BalanceSheet from "@/views/panel/balanceSheet/BalanceSheet";
export default {
  components: {BalanceSheet, IncomeStatement, SortInventoryError },
  mixins: [MFormMixin, CompanyMixin],
  data() {
    return {
      targetFinancialYear: null,
      password: null,
      financialYears: [],
      entities: {},

      confirmDialog: false,
      balanceDialog: false,
      incomeStatementDialog: false,
      operation: null,

      errors: [],
      errorDialog: false,

      headers: [
        {
          text: "عملیات",
          value: "operation",
        },
        {
          text: "کاربر",
          value: "operator_name",
        },
        {
          text: "تاریخ",
          value: "created_at",
          type: "datetime",
        },
        {
          text: "سال مالی مقصد",
          value: "to_financial_year_name",
        },
      ],
    };
  },
  computed: {
    title() {
      return this.setDocumentTitle("عملیات بستن و انتقال")
    },
    listItems() {
      const financialYear = this.financialYears.filter((o) => o.id == this.financialYear.id)[0];
      if (!financialYear) return [];
      return financialYear.operations;
    },
    selectItems() {
      return this.financialYears.filter((o) => !o.is_closed && o.id != this.financialYear.id);
    },
    canPerform() {
      return this.targetFinancialYear && Object.values(this.entities).reduce((p, c) => p || c, false);
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.getFinancialYears((data) => {
        this.financialYears = data;
      });
    },
    clearForm() {
      this.operation = null;
      this.targetFinancialYear = null;
      this.password = null;
      this.confirmDialog = false;
    },
    openConfirmDialog(operation) {
      this.operation = operation;
      this.confirmDialog = true;
    },
    confirm() {
      if (this.operation == "close") this.close();
      else if (this.operation == "move") this.move();
      else if (this.operation == "close-and-move") this.closeAndMove();
      else if (this.operation == "cancel-closing") this.cancelClosing();
    },
    close() {},
    closeAndMove() {
      this.request({
        url: this.endpoint("companies/closeFinancialYear"),
        method: "post",
        data: {
          target_financial_year: this.targetFinancialYear.id,
          password: this.password,
          entities: this.entities,
        },
        success: (data) => {
          this.clearForm();
          this.successNotify();
          this.$store.commit("setUser", data);
          this.getData();
        },
        error: this.error,
      });
    },
    move() {
      this.request({
        url: this.endpoint("companies/moveFinancialYear"),
        method: "post",
        data: {
          target_financial_year: this.targetFinancialYear.id,
          password: this.password,
          entities: this.entities,
        },
        success: (data) => {
          this.clearForm();
          this.successNotify();
          this.$store.commit("setUser", data);
        },
        error: this.error,
      });
    },
    error(error) {
      const errors = error.response.data[0]["messages"];
      if (typeof errors[0] == typeof "") {
        this.handleError(error, undefined);
      } else {
        this.errors = errors;
        this.errorDialog = true;
      }
    },
    cancelClosing() {
      this.request({
        url: this.endpoint("companies/cancelFinancialYearClosing"),
        method: "post",
        data: {
          password: this.password,
        },
        success: (data) => {
          this.clearForm();
          this.successNotify();
          this.$store.commit("setUser", data);
          this.getData();
        },
      });
    },
  },
};
</script>
